<template>
    <div class="pandoraMenuTabsitem">
        <a v-if="props.href" :href="props.href" role="button" :aria-label="props.text ?? ''"
            :class="[titleactive == props.text && 'isActive']">{{ props.text }}</a>
        <a v-else role="menu" :aria-label="props.text ?? ''" :class="[titleactive == props.text && 'isActive']">{{
            props.text }}</a>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    text: {
        type: String,
        default: ''
    },
    href: {
        type: String,
        default: ''
    },
    titleactive: {
        type: String,
        default: ''
    }
});
</script>

<style scoped>
.pandoraMenuTabsitem {
    position: relative;
    display: block;
    opacity: 0;
    text-align: left;
}

.menuContainer a {
    background: #FFF;
    color: #444;
    text-decoration: none;
    width: inherit;
    transition: background 0.5s, color 0.5s, transform 0.5s;
    padding: 13px 8px;
    margin-inline: 8px;
    box-sizing: border-box;
    position: relative;
    font-family: Rubik-semibold, sans-serif;
    font-size: 14px;
}

.pandoraMenuTabs .pandoraMenuTabsitem a {
    white-space: nowrap;
    display: block;
    cursor: pointer;
}

.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem {
    pointer-events: all;
    opacity: 1;
}

.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem>a {
    background: #272833;
    color: #E2E4EA;
    text-decoration: none;
}

.isActive {
    background: #FFF !important;
    color: #272833 !important;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}

.menuContainer {
    margin-top: 40px;
    margin-left: 40px;
}

.menuContainer a:hover:before {
    content: '';
    top: 0;
    left: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
}

.pandoraMenuTabsitem>.pandoraMenuTabs>.pandoraMenuTabsitem>.pandoraMenuTabs>.pandoraMenuTabsitem {
    transition: transform 0.1s, opacity 0.1s;
    transform: translateX(195px) translateY(0%);
    opacity: 0;
}

.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem>.pandoraMenuTabs>.pandoraMenuTabsitem {
    transition: transform 0.3s, opacity 0.3s;
    transform: translateY(150%);
    opacity: 0;
}

.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem:hover>.pandoraMenuTabs>.pandoraMenuTabsitem,
.menuContainer>.pandoraMenuTabs>.pandoraMenuTabsitem.hover>.pandoraMenuTabs>.pandoraMenuTabsitem {
    transform: translateY(0%);
    opacity: 1;
}

.pandoraMenuTabsitem>.pandoraMenuTabs>.pandoraMenuTabsitem:hover>.pandoraMenuTabs>.pandoraMenuTabsitem,
.pandoraMenuTabsitem>.pandoraMenuTabs>.pandoraMenuTabsitem.hover>.pandoraMenuTabs>.pandoraMenuTabsitem {
    transform: translateX(0) translateY(0%);
    opacity: 1;
}
</style>